import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Spinner } from 'react-bootstrap';

const MENU_WIDTH = 210;

const OrderRowContextMenu = ({ open, position, items, onClose }) => {
  const menuRef = useRef(null);
  const isActionLoading = items.some(item => item.loading);

  useLayoutEffect(() => {
    if (!open || !menuRef.current || !position) return;

    const menu = menuRef.current;
    const { width, height } = menu.getBoundingClientRect();
    let x = position.x;
    let y = position.y;

    if (x + width > window.innerWidth) {
      x = window.innerWidth - width - 8;
    }
    if (y + height > window.innerHeight) {
      y = window.innerHeight - height - 8;
    }

    menu.style.left = `${Math.max(8, x)}px`;
    menu.style.top = `${Math.max(8, y)}px`;
  }, [open, position, items]);

  useEffect(() => {
    if (!open) return;

    const handlePointerDown = event => {
      if (isActionLoading) return;
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleKeyDown = event => {
      if (event.key === 'Escape' && !isActionLoading) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onClose, isActionLoading]);

  if (!open || !position) return null;

  return createPortal(
    <div
      ref={menuRef}
      className="orders-row-context-menu"
      style={{ left: position.x, top: position.y, width: MENU_WIDTH }}
      role="menu"
    >
      {items.map(item => {
        const Icon = item.icon;
        return (
          <button
            key={item.key}
            type="button"
            role="menuitem"
            disabled={item.disabled || item.loading}
            className={`orders-row-context-menu__item${
              item.variant === 'danger' ? ' orders-row-context-menu__item--danger' : ''
            }${item.disabled || item.loading ? ' orders-row-context-menu__item--disabled' : ''}`}
            onClick={async () => {
              if (item.disabled || item.loading) return;
              await item.action();
            }}
          >
            {item.loading ? (
              <Spinner
                animation="border"
                size="sm"
                role="status"
                className="orders-row-context-menu__icon"
                style={{ width: 16, height: 16, borderWidth: 2 }}
              />
            ) : (
              Icon && <Icon size={16} className="orders-row-context-menu__icon" />
            )}
            <span>{item.label}</span>
          </button>
        );
      })}
    </div>,
    document.body
  );
};

export default OrderRowContextMenu;
